import React, { useEffect, useState } from 'react';
import { FaUpload } from 'react-icons/fa';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
// import Editor from 'react-simple-wysiwyg';
import ReactQuill from "react-quill-new";
import { getList, updateData } from '../../hooks/api/utils';

const EditService = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id, service } = location.state || {};
  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});
  const [imagePreview, setImagePreview] = useState('');
  

  const [formData, setFormData] = useState({
    name: '',
    title: '',
    description: '',
    image: null,
    // features: '',
    is_active: 'true',
  });

  useEffect(() => {
    getList('/admin-panel/active-industries/', setLoading);
    if (service) {
      setFormData({
        name: service.name,
        title: service.title,
        description: service.description,
        image: null, 
        // features: service.features,
        is_active: service.is_active.toString(),
      });
      setImagePreview(service.image);
    }
  }, [id]);

  const handleChange = (e) => {
  const { name, value, files } = e.target;
  if (name === 'image') {
    const file = files[0];
    setFormData((prev) => ({
      ...prev,
      image: file,
    }));
    if (file) {
      setImagePreview(URL.createObjectURL(file)); 
    }
  } else {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  }
  setErrors({});
};

 const handleEditorChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      description: value,
    }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = 'Name is required';
    if (!formData.title.trim()) newErrors.title = 'Title is required';
    if (!formData.description.trim())
      newErrors.description = 'Description is required';
    // if (!formData.features.trim()) newErrors.features = 'Features are required';
    if (formData.is_active !== 'true' && formData.is_active !== 'false') {
      newErrors.is_active = 'is_active must be "true" or "false"';
    }
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const payload = new FormData();
    for (const key in formData) {
      if (formData[key] !== null && formData[key] !== undefined) {
        payload.append(key, formData[key]);
      }
    }

    setIsSubmitting(true);
    await updateData(
      '/admin-panel/services/',
      id,
      setLoading,
      payload,
      navigate,
      '/services'
    );
    setIsSubmitting(false);
  };

  return (
    
      <div className="rightContent">
        <div className="doc_info">
          <div className="row g-4">
            <div className="col-md-12">
              <div className="padding-inner border-radius-20 bg-white">
                <h4 className="mb-4">Edit Service</h4>
                <form onSubmit={handleSubmit}>
                  <div className="row g-4">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label>
                          Service Name<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          placeholder="Enter service name"
                        />
                        {errors.name && (
                          <div className="text-danger">{errors.name}</div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="form-group">
                        <label>
                          Title<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          name="title"
                          value={formData.title}
                          onChange={handleChange}
                          placeholder="Enter title"
                        />
                        {errors.title && (
                          <div className="text-danger">{errors.title}</div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="form-group">
                        <label>
                          Description<span className="text-danger">*</span>
                        </label>
                         {/* <Editor
                        value={formData.description}
                        onChange={(e) => handleEditorChange(e.target.value)}
                        style={{ minHeight: '200px' }}
                      />
                      {errors.description && (
                        <div className="text-danger">
                          {errors.description}
                        </div>
                      )} */}
                      <ReactQuill
                      theme="snow"
                      value={formData.description}
                      onChange={handleEditorChange}
                      style={{ minHeight: '160px', marginBottom: '40px', height:'200px' }}
                    />
                    {errors.description && <div className="text-danger">{errors.description}</div>}
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="form-group">
                        <label>Update Picture (optional)</label>
                        <div className="custom-file-upload">
                          <input
                            type="file"
                            id="fileInput"
                            hidden
                            name="image"
                            onChange={handleChange}
                          />
                          <label htmlFor="fileInput" className="upload-box">
                            <span>
                              {formData.image
                                ? formData.image.name
                                : imagePreview
                                ? imagePreview.split("/").pop()
                                : "Upload"}
                            </span>
                            <FaUpload className="upload-icon" />
                          </label>
                          {errors.image && (
                            <div className="text-danger">{errors.image}</div>
                          )}
                        </div>
                        {imagePreview && (
                          <div className="mt-3">
                            <img
                              src={imagePreview}
                              alt="Preview"
                              style={{
                                maxWidth: "200px",
                                maxHeight: "200px",
                                borderRadius: "10px",
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="d-flex gap-3 justify-content-end">
                        <NavLink to="/services" className="transparent_btn">
                          Cancel
                        </NavLink>
                        <button
                          type="submit"
                          className="blue_btn"
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? "Updating..." : "Update"}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

export default EditService;
